import React from 'react';
import { Helmet } from 'react-helmet-async';
import WelcomeBanner from './WelcomeBanner';
import ServiceSection from './ServiceSection';
import ProcessSection from './ProcessSection';
import CommunitySection from './CommunitySection';
import TestimonialSection from './TestimonialSection';
import NewsletterSection from './NewsletterSection';
import FAQSection from './FAQSection';
import VacancyListing from './VacancyListing';

function HomePage() {
    return (
        <>
            <Helmet>
                <title>Welcome | Livability Care</title>
            </Helmet>
            <div className="min-h-screen">
                <WelcomeBanner />
                <ServiceSection />
                <ProcessSection />
                {/* <CommunitySection /> */}
                <VacancyListing />
                <TestimonialSection 
                imageSrc="/PeopleChillingOut.jpg" 
                imageAlt="People Chilling Out"
                />
                {/* <NewsletterSection /> */}
                {/* <FAQSection /> */}
                {/* Additional content can be added here */}
            </div>
        </>
    );
}

export default HomePage;
